import React from "react";
import { Box } from "@mui/material";
import { motion } from "framer-motion";
import FloatingIcons from "./FloatingIcons";

const MotionBox = motion(Box);

export default function BackgroundEffects() {
  return (
    <>
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          zIndex: 0,
          backgroundImage: `
            radial-gradient(circle at 15% 20%, rgba(0, 200, 83, 0.12), transparent 28%),
            radial-gradient(circle at 85% 15%, rgba(8, 45, 99, 0.10), transparent 30%),
            radial-gradient(circle at 50% 90%, rgba(0, 150, 136, 0.10), transparent 30%)
          `,
        }}
      />

      <MotionBox
        animate={{ rotate: 360 }}
        transition={{ duration: 35, repeat: Infinity, ease: "linear" }}
        sx={{
          position: "absolute",
          width: 420,
          height: 420,
          borderRadius: "50%",
          border: "1px dashed rgba(8,45,99,0.18)",
          top: -120,
          right: -100,
          zIndex: 0,
        }}
      />

      <MotionBox
        animate={{ y: [0, -18, 0] }}
        transition={{ duration: 5, repeat: Infinity }}
        sx={{
          position: "absolute",
          width: 260,
          height: 260,
          borderRadius: "36px",
          background:
            "linear-gradient(135deg, rgba(0,200,83,0.13), rgba(8,45,99,0.06))",
          bottom: -80,
          left: -70,
          transform: "rotate(18deg)",
          zIndex: 0,
        }}
      />

      <FloatingIcons />
    </>
  );
}
